import React, {Component} from 'react';
import PropTypes from 'prop-types';


class SignatureComponent extends React.Component {
    componentDidMount() {
        this.$el = window.$(this.el);
        this.$clear = window.$(this.clear);
        //this.$signatureJSON = window.$(this.signatureJSON);
        this.$el.signature({
            background: '#fff',
           // syncField: '#signatureJSON'
        });
        this.$clear.click(() => {
            //console.log(this.$signatureJSON.val());
            this.$el.signature('clear');
            this.$el.signature({background: 'white'});
            });
        if(typeof this.props.signatureCallback !== "undefined") //push function to parent Component so we have interface to obtain the data
            this.props.signatureCallback(() => {
                return {
                    'signature_json' : this.$el.signature('toJSON'),
                    'signature_png' :  this.$el.signature('toDataURL')
                };
            });
    }

    render() {
        return <>
            <div ref={el => this.el = el} id="id_signature" className="signature kbw-signature">
                {/*<canvas width="721" height="250">Your browser doesn't support signing</canvas>*/}
            </div>
           {/* <input ref={el => this.signatureJSON = el} type={'hidden'} id="signatureJSON" />*/}
            <h3 className="label_signature">Add Your Signature <span className="star">*</span></h3>
            <span ref={el => this.clear = el} className="clear_signature">Clear</span>
        </>;
    }
}
SignatureComponent.propTypes  = {
    signatureCallback : PropTypes.func,
};

export default SignatureComponent;